import store from '@/state/store'
import { hasLineOrderFeatureAccess } from '@/helpers/tms-line-order'

export const fieldsDeliveryOrder = (context) => {
  const getFeatureFlagValue = store.getters['identity/getFeatureFlagValue']

  return [
    {
      label: context.$t('delivery.fields.deliveryNumber'),
      key: 'number',
      isSortable: true,
      isRedirectable: true,
      isLocked: true,
    },
    {
      label: 'Line Order',
      key: 'line_order',
      isSortable: true,
      isLocked: true,
      isShow: hasLineOrderFeatureAccess() ? true : false,
    },
    {
      label: context.$t('delivery.fields.transitShipment'),
      key: 'transit_shipment',
      isSortable: false,
      isShow: true,
      isLocked: true,
    },
    {
      label: context.$t('delivery.fields.transitLocation'),
      key: 'transit_location',
      isSortable: false,
      thClass: 'mc-table--300',
      isShow: true,
      isLocked: true,
    },
    {
      label: context.$t('delivery.fields.status'),
      key: 'status.name',
      isSortable: true,
      isLocked: true,
    },
    {
      label: context.$t('delivery.fields.shipmentNumber'),
      key: 'shipment_number',
      isSortable: false,
      isEllipsis: true,
    },
    {
      label: context.$t('delivery.fields.referenceNumberText'),
      key: 'reference_number',
      isSortable: false,
      isEllipsis: true,
    },
    {
      label: context.$t('delivery.fields.referenceNumber'),
      key: 'external_reference_number',
      isSortable: true,
      scopes: [
        'tms-integration-accurate:create',
        'tms-integration-accurate:read',
        'tms-integration-accurate:delete',
        'tms-integration-accurate:update',
      ],
    },
    { label: context.$t('delivery.fields.createdDate'), key: 'created_on', isSortable: true },
    {
      label: 'Target Diambil',
      key: 'expected_pickup_on',
      isSortable: true,
    },
    {
      label: 'Target Terkirim',
      key: 'expected_delivered_on',
      isSortable: true,
    },
    {
      label: 'Grup Pengguna',
      key: 'user_group.name',
      isSortable: false,
      isEllipsis: true,
    },
    {
      label: context.$t('fleetTask.fields.productCategory'),
      key: 'product_categories',
      scopes: ['fleet-task-single-category-deliveries:read'],
      thStyle: 'min-width: 300px',
    },
    {
      label: context.$t('delivery.fields.customerName'),
      key: 'shipped_customer.name',
      isSortable: true,
      isEllipsis: true,
    },
    {
      label: 'Min. Temperatur',
      key: 'load_min_temperature',
      isSortable: false,
      formatter: (value) => ((value ?? '') === '' ? `-` : `${value} °C`),
      scopes: ['tms-cold-chain:read'],
    },
    {
      label: 'Max. Temperatur',
      key: 'load_max_temperature',
      isSortable: false,
      formatter: (value) => ((value ?? '') === '' ? `-` : `${value} °C`),
      scopes: ['tms-cold-chain:read'],
    },
    {
      label: context.$t('delivery.fields.originAddress'),
      key: 'origin_address.name',
      isSortable: true,
      isEllipsis: true,
    },
    {
      label: context.$t('delivery.fields.originCity'),
      key: 'origin_address.city',
      isSortable: true,
      isEllipsis: true,
    },
    {
      label: context.$t('delivery.fields.destinationAddress'),
      key: 'destination_address.name',
      isSortable: true,
      isEllipsis: true,
    },
    {
      label: context.$t('delivery.fields.destinationCity'),
      key: 'destination_address.city',
      isSortable: true,
      isEllipsis: true,
    },
    { label: context.$t('delivery.fields.weightTotal'), key: 'load_weight', isSortable: true },
    { label: context.$t('delivery.fields.volume'), key: 'load_volume', isSortable: true },
  ]
}
